window.anvil.block('hero-background-text', el => {
	window.gsap.to('.bg-image', {
		y: 100,             // adjust how much the image moves
		ease: 'none',
		scrollTrigger: {
			trigger: '.background',
			start: 'top 92px',
			end: 'bottom 92px',
			scrub: true
		}
	});

	window.gsap.from('.reveal-image', {
		clipPath: 'inset(0 100% 0 0)', // fully hidden
		ease: 'power2.out',
		duration: 1.5,
	});

	window.gsap.utils.toArray('.animate-scroll-up').forEach(box => {
		window.gsap.from(box, {
			y: '100%',                  // move to original position
			opacity: 0,
			ease: 'power2.out',
			duration: 1.5,
		});
	});
});
